import React from 'react';
import type { JSX } from '@gov-design-system-ce/components';
import { GovFormSearch } from '@gov-design-system-ce/react';
import type { FormInputProps } from '@gov-nx/ui/web';
import { Button, FormInput, Icon } from '@gov-nx/ui/web';

interface Props extends JSX.GovFormSearch {
	input: FormInputProps;
	button: {
		'aria-label'?: string;
	};
}

export const FormSearch = ({ input, button }: Props) => {
	const { label, ...inputProps } = input;
	return (
		<GovFormSearch
			size="m"
			color="neutral"
			button={
				<Button
					slot="button"
					color="primary"
					type="solid"
					nativeType="submit"
					size="s"
					iconStart={
						<Icon
							type="components"
							name="search"
						/>
					}
					{...button}
				/>
			}>
			<FormInput
				{...inputProps}
				field={{
					slot: 'input',
					...input.field,
				}}
				label={{ ...label, className: 'sr-only' }}
			/>
		</GovFormSearch>
	);
};
